import { z } from 'zod';

import { createEventBus } from './utils/createEventBus';
import { singleton } from './utils/singleton';

export const LoginEventSchema = z.object({
  AccessToken: z.string(),
  IdToken: z.string(),
  redirectTo: z.string().optional(),
});

export const LogoutEventSchema = z.object({
  success: z.boolean(),
});

export const PostHogCaptureEventSchema = z.object({
  event: z.string(),
  properties: z.record(z.any()).optional(),
});

export const PostHogIdentifyEventSchema = z.object({
  distinctId: z.string(),
  properties: z.record(z.any()).optional(),
});

export const PostHogResetEventSchema = z.object({
  resetDeviceId: z.boolean().optional(),
});

const eventConfig = {
  'mife:login': LoginEventSchema,
  'mife:logout': LogoutEventSchema,
  'posthog:capture': PostHogCaptureEventSchema,
  'posthog:identify': PostHogIdentifyEventSchema,
  'posthog:reset': PostHogResetEventSchema,
};

export const initEventBus = () => singleton('eventBus', () => createEventBus(eventConfig));
